
import SvgIcon from '@/components/SvgIcon'// svg component
SvgIcon.install = function (Vue){
    Vue.component(SvgIcon.name, SvgIcon);
}
export default SvgIcon;
